// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { createPortal } from "react-dom";
// import { IoChevronDown, IoSearch } from "react-icons/io5";
// import "./searchabledropdown.css";

// const SearchableDropdown = ({
//   options,
//   selectedValues,
//   onChange,
//   placeholder,
//   isMultiSelect = false,
//   labelField = "name",
//   valueField = "id",
//   disabled = false,
//   error = false,
//   dataLoadError = null,
//   allowClear = false,
//   className,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const wrapperRef = useRef(null);
//   const dropdownRef = useRef(null);
//   const [dropdownStyle, setDropdownStyle] = useState({});

//   const filteredOptions = !Array.isArray(labelField)
//     ? options.filter((option) =>
//         option && typeof option[labelField] === "string"
//           ? option[labelField].toLowerCase().includes(searchTerm.toLowerCase())
//           : false
//       )
//     : options.filter((option) =>
//         labelField
//           .map((label) =>
//             option && typeof option[label] === "string"
//               ? option[label].toLowerCase()
//               : false
//           )
//           .join(" ")
//           .includes(searchTerm.toLowerCase())
//       );

//   const calculateDropdownPosition = useCallback(() => {
//     if (wrapperRef.current) {
//       const rect = wrapperRef.current.getBoundingClientRect();
//       setDropdownStyle({
//         position: "absolute",
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width,
//         zIndex: 9999,
//       });
//     }
//   }, []);

//   const handleSelect = useCallback(
//     (optionValue) => {
//       if (isMultiSelect) {
//         const newValues = selectedValues.includes(optionValue)
//           ? selectedValues.filter((v) => v !== optionValue)
//           : [...selectedValues, optionValue];
//         onChange(newValues);
//       } else {
//         onChange(optionValue);
//         setIsOpen(false);
//       }
//     },
//     [isMultiSelect, selectedValues, onChange]
//   );

//   useEffect(() => {
//     const currentWrapperRef = wrapperRef.current;
//     const currentDropdownRef = dropdownRef.current;

//     const handleClickOutside = (event) => {
//       if (
//         currentWrapperRef &&
//         !currentWrapperRef.contains(event.target) &&
//         currentDropdownRef &&
//         !currentDropdownRef.contains(event.target)
//       ) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     if (isOpen) {
//       calculateDropdownPosition();
//       window.addEventListener("scroll", calculateDropdownPosition, true);
//       window.addEventListener("resize", calculateDropdownPosition);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       window.removeEventListener("scroll", calculateDropdownPosition, true);
//       window.removeEventListener("resize", calculateDropdownPosition);
//     };
//   }, [isOpen, calculateDropdownPosition]);

//   const getDisplayValue = () => {
//     if (isMultiSelect) {
//       if (selectedValues.length === 0) return placeholder;
//       if (selectedValues.length === 1) {
//         const selectedOption = options.find(
//           (opt) => opt[valueField] === selectedValues[0]
//         );
//         return selectedOption
//           ? Array.isArray(labelField)
//             ? labelField.map((o) => selectedOption[o]).join(" | ")
//             : selectedOption[labelField]
//           : "1 selected";
//       }
//       return `${selectedValues.length} items selected`;
//     } else {
//       const selectedOption = options.find(
//         (opt) => String(opt[valueField]) === String(selectedValues)
//       );
//       return selectedOption
//         ? Array.isArray(labelField)
//           ? labelField.map((o) => selectedOption[o]).join(" | ")
//           : selectedOption[labelField]
//         : placeholder;
//     }
//   };

//   return (
//     <div
//       className={`searchable-dropdown-container ${className || ""}`}
//       ref={wrapperRef}
//     >
//       <button
//         type="button"
//         className={`dropdown-trigger ${error ? "invalid-field" : ""}`}
//         onClick={() => !disabled && setIsOpen(!isOpen)}
//         disabled={disabled}
//       >
//         <span>{getDisplayValue()}</span>
//         <IoChevronDown className={`dropdown-chevron ${isOpen ? "open" : ""}`} />
//       </button>
//       {isOpen &&
//         createPortal(
//           <div
//             className="dropdown-panel"
//             style={dropdownStyle}
//             ref={dropdownRef}
//           >
//             <div className="dropdown-search-container">
//               <input
//                 type="text"
//                 className="dropdown-search-input"
//                 placeholder="Search..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 autoFocus
//               />
//               <IoSearch className="search-icon" />
//             </div>
//             <ul className="dropdown-options-list">
//               {dataLoadError && (
//                 <li className="dropdown-option-message">{dataLoadError}</li>
//               )}
//               {!dataLoadError && allowClear && !isMultiSelect && (
//                 <li
//                   className="dropdown-option clear-option"
//                   onClick={() => handleSelect("")}
//                 >
//                   — Clear Selection —
//                 </li>
//               )}
//               {!dataLoadError && filteredOptions.length > 0
//                 ? filteredOptions.map((option) => {
//                     const isSelected = isMultiSelect
//                       ? selectedValues.includes(option[valueField])
//                       : String(selectedValues) === String(option[valueField]);
//                     return (
//                       <li
//                         key={option[valueField]}
//                         className={`dropdown-option ${
//                           isSelected ? "selected" : ""
//                         }`}
//                         onClick={() => handleSelect(option[valueField])}
//                       >
//                         {isMultiSelect && (
//                           <input
//                             type="checkbox"
//                             checked={isSelected}
//                             readOnly
//                             className="dropdown-checkbox"
//                           />
//                         )}
//                         {Array.isArray(labelField)
//                           ? labelField
//                               .filter((o) => option[o] != null)
//                               .map((o) => option[o])
//                               .join(" | ")
//                           : option[labelField]}
//                       </li>
//                     );
//                   })
//                 : !dataLoadError && (
//                     <li className="dropdown-option-message">
//                       No results found
//                     </li>
//                   )}
//             </ul>
//           </div>,
//           document.body
//         )}
//     </div>
//   );
// };

// export default SearchableDropdown;














import React, { useState, useRef, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { IoChevronDown, IoSearch } from "react-icons/io5";
import "./searchabledropdown.css";

const SearchableDropdown = ({
  options,
  selectedValues,
  onChange,
  placeholder,
  isMultiSelect = false,
  labelField = "name",
  valueField = "id",
  disabled = false,
  error = false,
  dataLoadError = null,
  allowClear = false,
  className,
  isOpen: controlledIsOpen,      // 🔥 NEW: Controlled state from parent
  onToggle: controlledOnToggle,   // 🔥 NEW: Controlled toggle from parent
}) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});

  // 🔥 NEW: Use controlled or uncontrolled state
  const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;
  const setIsOpen = controlledOnToggle !== undefined ? controlledOnToggle : setInternalIsOpen;

  const filteredOptions = !Array.isArray(labelField)
    ? options.filter((option) =>
        option && typeof option[labelField] === "string"
          ? option[labelField].toLowerCase().includes(searchTerm.toLowerCase())
          : false
      )
    : options.filter((option) =>
        labelField
          .map((label) =>
            option && typeof option[label] === "string"
              ? option[label].toLowerCase()
              : false
          )
          .join(" ")
          .includes(searchTerm.toLowerCase())
      );

  const calculateDropdownPosition = useCallback(() => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: "absolute",
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        zIndex: 9999,
      });
    }
  }, []);

  const handleSelect = useCallback(
    (optionValue) => {
      if (isMultiSelect) {
        const newValues = selectedValues.includes(optionValue)
          ? selectedValues.filter((v) => v !== optionValue)
          : [...selectedValues, optionValue];
        onChange(newValues);
        
        // 🔥 NEW: Auto-close after selection in controlled mode
        if (controlledOnToggle && newValues.length > selectedValues.length) {
          setTimeout(() => setIsOpen(false), 200);
        }
      } else {
        onChange(optionValue);
        setIsOpen(false);
      }
    },
    [isMultiSelect, selectedValues, onChange, controlledOnToggle, setIsOpen]
  );

  useEffect(() => {
    const currentWrapperRef = wrapperRef.current;
    const currentDropdownRef = dropdownRef.current;

    const handleClickOutside = (event) => {
      if (
        currentWrapperRef &&
        !currentWrapperRef.contains(event.target) &&
        currentDropdownRef &&
        !currentDropdownRef.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    if (isOpen) {
      calculateDropdownPosition();
      window.addEventListener("scroll", calculateDropdownPosition, true);
      window.addEventListener("resize", calculateDropdownPosition);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", calculateDropdownPosition, true);
      window.removeEventListener("resize", calculateDropdownPosition);
    };
  }, [isOpen, calculateDropdownPosition, setIsOpen]);

  const getDisplayValue = () => {
    if (isMultiSelect) {
      if (selectedValues.length === 0) return placeholder;
      if (selectedValues.length === 1) {
        const selectedOption = options.find(
          (opt) => opt[valueField] === selectedValues[0]
        );
        return selectedOption
          ? Array.isArray(labelField)
            ? labelField.map((o) => selectedOption[o]).join(" | ")
            : selectedOption[labelField]
          : "1 selected";
      }
      return `${selectedValues.length} items selected`;
    } else {
      const selectedOption = options.find(
        (opt) => String(opt[valueField]) === String(selectedValues)
      );
      return selectedOption
        ? Array.isArray(labelField)
          ? labelField.map((o) => selectedOption[o]).join(" | ")
          : selectedOption[labelField]
        : placeholder;
    }
  };

  return (
    <div
      className={`searchable-dropdown-container ${className || ""}`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className={`dropdown-trigger ${error ? "invalid-field" : ""}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span>{getDisplayValue()}</span>
        <IoChevronDown className={`dropdown-chevron ${isOpen ? "open" : ""}`} />
      </button>
      {isOpen &&
        createPortal(
          <div
            className="dropdown-panel"
            style={dropdownStyle}
            ref={dropdownRef}
          >
            <div className="dropdown-search-container">
              <input
                type="text"
                className="dropdown-search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />
              <IoSearch className="search-icon" />
            </div>
            <ul className="dropdown-options-list">
              {dataLoadError && (
                <li className="dropdown-option-message">{dataLoadError}</li>
              )}
              {!dataLoadError && allowClear && !isMultiSelect && (
                <li
                  className="dropdown-option clear-option"
                  onClick={() => handleSelect("")}
                >
                  — Clear Selection —
                </li>
              )}
              {!dataLoadError && filteredOptions.length > 0
                ? filteredOptions.map((option) => {
                    const isSelected = isMultiSelect
                      ? selectedValues.includes(option[valueField])
                      : String(selectedValues) === String(option[valueField]);
                    return (
                      <li
                        key={option[valueField]}
                        className={`dropdown-option ${
                          isSelected ? "selected" : ""
                        }`}
                        onClick={() => handleSelect(option[valueField])}
                      >
                        {isMultiSelect && (
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="dropdown-checkbox"
                          />
                        )}
                        {Array.isArray(labelField)
                          ? labelField
                              .filter((o) => option[o] != null)
                              .map((o) => option[o])
                              .join(" | ")
                          : option[labelField]}
                      </li>
                    );
                  })
                : !dataLoadError && (
                    <li className="dropdown-option-message">
                      No results found
                    </li>
                  )}
            </ul>
          </div>,
          document.body
        )}
    </div>
  );
};

export default SearchableDropdown;//end of the code 